import VueRouter from 'vue-router'

// Containers
import FullContainer from '@/containers/Full.vue'
import AuthContainer from '@/containers/Auth.vue'
import ConfirmationContainer from '@/containers/Confirmation.vue'
// import EmptyContainer from '@/containers/Empty.vue'

// Errors
import Error404 from '@/views/Error/PageNotFound.vue'

// Views
import Frontend from '@/views/Frontend.vue'
import Dashboard from '@/views/Dashboard.vue'
import Profile from '@/views/Profile.vue'

import Finance from '@/views/Finance.vue'
import FinanceAccounts from '@/views/Finance/Accounts.vue'
import FinanceHistory from '@/views/Finance/History.vue'

import Deposits from '@/views/Deposits.vue'
import Credits from '@/views/Credits.vue'

import Franchising from '@/views/Franchising.vue'
import Franchisee from '@/views/Franchising/Franchisee.vue'

import AdminOrders from '@/views/Admin/Orders.vue'

import AuthLogin from '@/views/Login.vue'
import AuthAutoLogin from '@/views/Auth/AutoLogin.vue'
import AuthLogout from '@/views/Logout.vue'
import AuthRegistration from '@/views/Registration.vue'
import AuthRemindPassword from '@/views/RemindPassword.vue'

import ConfirmRegistration from '@/views/Confirmation/Registration.vue'

export default new VueRouter({
    hashbang: false,
    // mode: 'history',
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [{
        path: '',
        name: 'Frontend',
        component: Frontend,
        meta: {
            label: 'Главная',
            auth: null
        }
    }, {
        path: '/auth',
        redirect: {
            name: 'AuthLogin'
        },
        component: AuthContainer,
        children: [{
            path: 'login',
            name: 'AuthLogin',
            component: AuthLogin,
            meta: {
                label: 'Вход',
                auth: false
            }
        }, {
            path: 'autologin/:token',
            name: 'AuthAutoLogin',
            component: AuthAutoLogin,
            meta: {
                auth: false
            }
        }, {
            path: 'logout',
            name: 'AuthLogout',
            component: AuthLogout,
            meta: {
                label: 'Выход',
                auth: true,
                confirm: true
            }
        }, {
            path: 'registration',
            name: 'AuthRegistration',
            component: AuthRegistration,
            meta: {
                label: 'Регистрация',
                auth: false
            }
        }, {
            path: 'remind',
            name: 'AuthRemindPassword',
            component: AuthRemindPassword,
            meta: {
                label: 'Восстановление пароля',
                auth: false
            }
        }]
    }, {
        path: '/cabinet',
        redirect: {
            name: 'Dashboard'
        },
        name: 'Cabinet',
        meta: {
            label: 'Кабинет'
        },
        component: FullContainer,
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                label: 'Сводка',
                auth: true
            }
        }, {
            path: 'profile',
            name: 'Profile',
            component: Profile,
            meta: {
                label: 'Профиль',
                auth: true
            }
        }, {
            path: 'franchising',
            name: 'Franchising',
            component: Franchising,
            meta: {
                label: 'Сотрудникам',
                auth: true
            },
            children: [{
                path: 'marketing',
                name: 'FranchisingMarketing',
                component: Error404,
                meta: {
                    label: 'Маркетинг',
                    auth: true
                }
            }, {
                path: 'franchisee',
                name: 'FranchisingFranchisee',
                component: Franchisee,
                meta: {
                    label: 'Франшизы',
                    auth: true
                }
            }]
        }, {
            path: 'finance',
            name: 'Finance',
            component: Finance,
            meta: {
                label: 'Финансы',
                auth: true
            },
            children: [{
                path: 'history',
                name: 'FinanceHistory',
                component: FinanceHistory,
                meta: {
                    label: 'История',
                    auth: true
                }
            }, {
                path: 'accounts',
                name: 'FinanceAccounts',
                component: FinanceAccounts,
                meta: {
                    label: 'Счета',
                    auth: true
                }
            }]
        }, {
            path: 'deposits',
            name: 'Deposits',
            component: Deposits,
            meta: {
                label: 'Депозиты',
                auth: true
            }
        }, {
            path: 'credits',
            name: 'Credits',
            component: Credits,
            meta: {
                label: 'Кредиты',
                auth: true
            }
        }]
    }, {
        path: '/admin',
        name: 'Admin',
        component: FullContainer,
        meta: {
            label: 'Админка',
            auth: ['admin']
        },
        children: [{
            path: 'dashboard',
            name: 'AdminDashboard',
            component: Error404,
            meta: {
                label: 'Админка',
                auth: ['admin']
            }
        }, {
            path: 'orders',
            name: 'AdminOrders',
            component: AdminOrders,
            meta: {
                label: 'Заказы',
                auth: ['admin']
            }
        }]
    }, {
        path: '/confirm',
        name: 'Confirmation',
        component: ConfirmationContainer,
        children: [{
            path: 'registration/:token',
            name: 'ConfirmRegistration',
            component: ConfirmRegistration
        }]
    }, {
        path: '/partner/:referrer',
        beforeEnter: (to, from, next) => {
            let referrer = encodeURIComponent(to.params['referrer'])

            let expires = new Date()
            expires.setTime(expires.getTime() + 12096e5)

            let updatedCookie = 'profi-bank_referrer' + '=' + referrer

            updatedCookie += '; expires=' + expires.toUTCString()
            document.cookie = updatedCookie

            next({name: 'AuthRegistration'})
        }
    }, {
        path: '*',
        component: Error404
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js